<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <!--ricerca -->
        <div class="card-title px-2 pt-2 mb-0">
          <div class="row">
            <div class="col-xl-2 mb-2">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKey" (ngModelChange)="searchCollaborator()" />
            </div>
            <!--filtro per lo stato-->
            <div class="col-xl-2 mb-2">
              <ng-select id="status" [(ngModel)]="filter_type" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchCollaborator()">
                <ng-option value="all">
                  <span class="font-small-4 font-weight-normal mr-1">{{ "TYPE" | translate }}</span>
                </ng-option>
                <ng-option *ngFor="let type of typeUser" [value]="type">
                  <span class="font-small-4 font-weight-normal">{{ type }}</span>
                </ng-option>
              </ng-select>
            </div>
            <!-- filtro data inizio -->
            <div class="col-xl-2 mb-2">
              <app-datepickr id="from" [defaultDate]="filter_contract_start_date" (onSelect)="filter_contract_start_date = $event; searchCollaborator()" [placeholder]="'FROM_START_DATE_CONTRACT' | translate" [displayMonths]="1"></app-datepickr>
            </div>
            <!-- filtro data fine -->
            <div class="col-xl-2 mb-2">
              <app-datepickr id="to" [defaultDate]="filter_contract_end_date" (onSelect)="filter_contract_end_date = $event; searchCollaborator()" [placeholder]="'TO_END_DATE_CONTRACT' | translate" [displayMonths]="1"></app-datepickr>
            </div>

            <div class="col-xl-4 text-right mb-2">
              <div class="w-fit d-inline-block mr-2" *ngIf="!_utilService.isMobile">
                <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
              </div>
              <a has_capability="create_collaborator" routerLink="/dashboard/collaborators/add" class="btn btn-outline-primary">{{ "ADD" | translate }}</a>
            </div>
          </div>
        </div>

        <!--desktop-->
        <div class="card-body p-0">
          <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30" [scrollbarH]="true" [rowHeight]="_utilService.isDesktop ? 60 : 160"
                         [limit]="tableLimit" [footerHeight]="50" [rows]="filterCollaborator" [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }">
            <ngx-datatable-column [name]="'FIRSTNAME' | translate" [prop]="'complete_name'" [width]="150" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a routerLink="/dashboard/collaborators/edit/{{ row.hash }}">{{ row.business_name ? row.business_name : row.complete_name }}</a>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TYPE' | translate" [sortable]="false" [width]="130" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.type_name }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'EMAIL' | translate" prop="email" [width]="190" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a *ngIf="row.email" [href]="'mailto:' + row.email" [ngbTooltip]="'SEND_EMAIL' | translate">{{ row.email }} </a>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'PHONE' | translate" prop="phone" [width]="130" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a *ngIf="row.phone" [href]="'tel:' + row.phone" [ngbTooltip]="'CALL' | translate">{{ row.phone }}</a>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'START_DATE' | translate" prop="start_date" [width]="130" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.start_date | date: 'dd/MM/YYYY' }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'END_DATE' | translate" prop="end_date" [width]="130" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.end_date ? _utilService.formatDate(row.end_date) : '-' }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CITY' | translate" [sortable]="false" prop="city_name" [width]="80" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.city_name || "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" [width]="90"
                                  *ngIf="_utilService.isDesktop && _authenticationService.hasCapabilities(['edit_collaborator', 'create_transformation', 'edit_collaborator', 'delete_collaborator'])"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div ngbDropdown container="body">
                  <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow" rippleEffect>
                    <span [data-feather]="'more-vertical'" class="cursor-pointer"></span>
                  </button>
                  <div ngbDropdownMenu>
                    <a routerLink="/dashboard/collaborators/edit/{{ row.hash }}" ngbDropdownItem *ngIf="_authenticationService.hasCapability('edit_collaborator')">
                      <span [data-feather]="'edit'" size="16" class="mr-50"></span> {{ "EDIT" | translate }}
                    </a>
                    <a (click)="transformCollaborateToEmployee(row)" ngbDropdownItem *ngIf="_authenticationService.hasCapability('create_transformation') && !isDisableCollaborator(row)">
                      <span [data-feather]="'edit'" size="16" class="mr-50"></span> {{ "TRANSFORM_TO_EMPLOYEE" | translate }}
                    </a>
                    <a (click)="disableUser(row.hash)" ngbDropdownItem class="text-warning" *ngIf="_authenticationService.hasCapability('edit_collaborator') && !isDisableCollaborator(row)">
                      <span [data-feather]="'archive'" size="16" class="mr-50"></span> {{ "DISABLE_USER" | translate }}
                    </a>
                    <a (click)="enableUser(row.hash)" ngbDropdownItem class="text-warning" *ngIf="_authenticationService.hasCapability('edit_collaborator') && isDisableCollaborator(row)">
                      <span [data-feather]="'target'" size="16" class="mr-50"></span> {{ "ENABLE_USER" | translate }}
                    </a>
                    <a (click)="deleteUser(row.hash)" ngbDropdownItem class="text-danger" *ngIf="_authenticationService.hasCapability('delete_collaborator')">
                      <span [data-feather]="'trash'" size="16" class="mr-50"></span> {{ "DELETE" | translate }}
                    </a>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <!--mobile - tablet-->
            <ngx-datatable-column [name]="'FIRSTNAME' | translate" [prop]="'complete_name'" [width]="170" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-10 pr-0">
                    <div class="text-capitalize">
                      <a routerLink="/dashboard/collaborators/edit/{{ row.hash }}">{{ row.business_name ? row.business_name : row.complete_name }}</a>
                    </div>
                    <div>
                      <span>{{ row.type_name }}</span>
                    </div>
                    <div>
                      <a *ngIf="row.email" [href]="'mailto:' + row.email" [ngbTooltip]="'SEND_EMAIL' | translate"> <i [data-feather]="'mail'" size="16" class="mr-50 text-info"></i> {{ row.email }} </a>
                    </div>
                    <div>
                      <a *ngIf="row.phone" [href]="'tel:' + row.phone" [ngbTooltip]="'CALL' | translate"> <i [data-feather]="'phone'" size="16" class="mr-50 text-success"></i> {{ row.phone }}</a>
                    </div>
                    <div>
                      <span>{{ row.addresses && row.addresses.length > 0 && row.addresses[0].city_name ? row.addresses[0].city_name : "-" }}</span>
                    </div>
                  </div>
                  <div class="col-2" *ngIf="_authenticationService.hasCapabilities(['edit_collaborator', 'create_transformation', 'edit_collaborator', 'delete_collaborator'])">
                    <div ngbDropdown container="body">
                      <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow" rippleEffect>
                        <span [data-feather]="'more-vertical'" class="cursor-pointer"></span>
                      </button>
                      <div ngbDropdownMenu>
                        <a routerLink="/dashboard/collaborators/edit/{{ row.hash }}" ngbDropdownItem *ngIf="_authenticationService.hasCapability('edit_collaborator')">
                          <span [data-feather]="'edit'" size="16" class="mr-50"></span> {{ "EDIT" | translate }}
                        </a>
                        <a (click)="transformCollaborateToEmployee(row)" ngbDropdownItem *ngIf="_authenticationService.hasCapability('create_transformation') && !isDisableCollaborator(row)">
                          <span [data-feather]="'edit'" size="16" class="mr-50"></span> {{ "TRANSFORM_TO_EMPLOYEE" | translate }}
                        </a>
                        <a (click)="disableUser(row.hash)" ngbDropdownItem class="text-warning" *ngIf="_authenticationService.hasCapability('edit_collaborator') && !isDisableCollaborator(row)">
                          <span [data-feather]="'archive'" size="16" class="mr-50"></span> {{ "DISABLE_USER" | translate }}
                        </a>
                        <a (click)="enableUser(row.hash)" ngbDropdownItem class="text-warning" *ngIf="_authenticationService.hasCapability('edit_collaborator') && isDisableCollaborator(row)">
                          <span [data-feather]="'target'" size="16" class="mr-50"></span> {{ "ENABLE_USER" | translate }}
                        </a>
                        <a (click)="deleteUser(row.hash)" ngbDropdownItem class="text-danger" *ngIf="_authenticationService.hasCapability('delete_collaborator')">
                          <span [data-feather]="'trash'" size="16" class="mr-50"></span> {{ "DELETE" | translate }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>
